import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "20", height: "12", x: "2", y: "6", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 12h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 12h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 12h.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FormInput";
const FormInput = memo(themed(Icon));
export {
  FormInput
};
//# sourceMappingURL=form-input.js.map
